module.exports = __webpack_public_path__ + "static/img/tt1.246a7897.png";